/* eslint-disable camelcase, prefer-destructuring */

import React, { Component } from 'react';
import axios from 'axios';

import { SearchParams } from '../../lib/utils';

const openingHoursOptions = [];
(function () {
	for (var i = 0; i <= 23; i++) {
		var h = i;
		var m = i < 12 ? 'am' : 'pm';
		if (h > 12) h -= 12;
		openingHoursOptions.push({ label: h + ':00 ' + m, value: i * 60 });
		openingHoursOptions.push({ label: h + ':30 ' + m, value: (i * 60) + 30 });
	}
})();

function convertIntToDate(num) {
  const opt = openingHoursOptions.find(o => o.value === num);
  if (opt) return opt.label;
  return num;
}

export default class Overview extends Component {
  componentDidMount() {
    const individualEmbedUuid = process.env.REACT_APP_PANDA_DOC_INDIVIDUAL_EMBED;

    const embedUuid = individualEmbedUuid;

    const queryParams = this.props.location.search;
    const params = new SearchParams(queryParams);
    const renewContractToken = params.get('renewContractToken');

    axios.post('/api/account/renew-contract', {
      renewContractToken,
    }).then(({ data }) => {
      if (data && !data.newsagency) return window.location.replace('/');

      const { newsagency } = data;
      const {
        abn,
        contactName,
        email,
        isLicensedPostOffice,
        phone,
        shopName,
        openingHours,
        shopAddress,
      } = newsagency;

      const splitName = contactName.split(' ');
      const givenNames = splitName.slice(0, splitName.length - 1).join(' ');
      const contact = {
        givenNames: givenNames || splitName[splitName.length - 1],
        surname: givenNames ? splitName[splitName.length - 1] : '',
        email,
        mobile: phone,
        shopName,
        licensedPostOffice: isLicensedPostOffice,
      };
      const address = {
        buildingName: shopAddress.name,
        shopNumber: shopAddress.number,
        street1: shopAddress.street1,
        street2: shopAddress.street2,
        suburb: shopAddress.suburb,
        state: shopAddress.state,
        postCode: shopAddress.postCode,
        shopName,
      };

      const account = Object.assign({ abn });

      const combinedAddress = [
        address.buildingName,
        address.shopNumber,
        address.floorLevel,
        address.street1,
        address.street2,
        address.suburb,
        address.state,
        address.postCode,
      ].filter(v => !!v).join(', ');

      const {
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        saturday,
        sunday,
      } = openingHours;

      window.pandadoc_embed_config = {
        embed_uuid: embedUuid,
        width: 1024,
        height: 700,
        element_id: 'eNzg4MzA1z',
        user: {
          first_name: contact.givenNames,
          last_name: contact.surname,
          email: contact.email,
        },
        widgets: {
          Agent: {
            contact_name: `${contact.givenNames} ${contact.surname}`,
            shop_name: address.shopName || '',
            acn_abn: account.abn || '',
            address: combinedAddress || '',
            tel: contact.mobile || '',
            email: contact.email || '',
            business_name: address.shopName || '',
            business_address: combinedAddress || '',
            monday_open: monday.open ? convertIntToDate(monday.from) : '-', monday_close: monday.open ? convertIntToDate(monday.to) : '-',
            tuesday_open: tuesday.open ? convertIntToDate(tuesday.from) : '-', tuesday_close: tuesday.open ? convertIntToDate(tuesday.to) : '-',
            wednesday_open: wednesday.open ? convertIntToDate(wednesday.from) : '-', wednesday_close: wednesday.open ? convertIntToDate(wednesday.to) : '-',
            thursday_open: thursday.open ? convertIntToDate(thursday.from) : '-', thursday_close: thursday.open ? convertIntToDate(thursday.to) : '-',
            friday_open: friday.open ? convertIntToDate(friday.from) : '-', friday_close: friday.open ? convertIntToDate(friday.to) : '-',
            saturday_open: saturday.open ? convertIntToDate(saturday.from) : '-', saturday_close: saturday.open ? convertIntToDate(saturday.to) : '-',
            sunday_open: sunday.open ? convertIntToDate(sunday.from) : '-', sunday_close: sunday.open ? convertIntToDate(sunday.to) : '-',
            final_business_name: contact.shopName || '',
            final_financial_institution: account.nameOfFinancialInstitution || '',
            final_bank_account_name: account.namesOnAccount || '',
            final_bsb_number: account.bsb || '',
            final_account_number: account.accountNumber || '',
          },
        },
        events: {
          loaded: () => {
            // console.log('loaded');
          },
          started: () => {
            // console.log('started');
          },
          completed: (doc) => {
            const contractDownloadLink = `https://app.pandadoc.com/a/#/document/v1/editor/${doc.uuid}/timeline`;
            axios.post('/api/account/renew-contract-data', {
              renewContractToken,
              contractDownloadLink,
            }).then(({ data }) => {
              window.location = 'https://blueshyft.com.au';
            }).catch((err) => {
              console.log(err);
            });
          },
          exception: () => {
            // console.log('exception');
          },
        },
      };

      window.amplitude.getInstance().logEvent('Account Next button Click ');
      const script = document.createElement('script');

      script.src = 'https://pd-web.s3.amazonaws.com/embed/embed.js';
      script.type = 'text/javascript';
      script.async = true;

      document.body.appendChild(script);
    }).catch((err) => {
      window.location.replace('/');
    });
  }

  render() {
    return (
      <div style={{ marginTop: 50 }}>
        <div id="eNzg4MzA1z" style={{ display: 'flex', justifyContent: 'center' }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/redesign/web/Contract/index.js